import * as yup from 'yup'

export const schemaTaxInvoiceNfeIo = yup.object().shape({
  daysToGenerateNFe: yup
    .number()
    .typeError('Preencha este campo')
    .moreThan(-1, 'Digite um número maior ou igual a zero')
    .lessThan(32, 'Digite um número menor ou igual a 31')
    .required(),
  nfeioApiKey: yup.string(),
  nfeioCompanyId: yup.string(),
  nfeioServiceCode: yup.string(),
  nfeioWebhookSecret: yup.string(),
})

export default schemaTaxInvoiceNfeIo
